'use client';
import AppIcon from '../../App/AppIcon';
import { useState, useEffect } from 'react';
import "./style.css";

type Props = {
  label?: string;
  name?: string;
  value?: string;
  error?: string;
  className?: string;
  containerClassName?: string;
  onlyNumber?: boolean;
  maxLength?: number;
  type?: 'normal' | 'number' | 'hour' | 'password' | 'currency' | 'time' | 'date';
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  handleOpenHelper?: () => void;
  helperText?: string;
};

const InputText = ({
  label,
  name,
  value = '',
  error,
  className,
  containerClassName,
  onlyNumber,
  maxLength,
  type = 'normal',
  required,
  placeholder,
  disabled,
  onChange,
  handleOpenHelper,
  helperText,
}: Props) => {
  const [inputValue, setInputValue] = useState(value);
  const [seePass, setSeePass] = useState(false);

  const handleValidation = (value: string) => {
    if (onlyNumber && !/^[0-9]*$/.test(value)) {
      return false;
    }

    if (type === 'currency' && !/^\d+(,\d{0,2})?$/.test(value)) {
      return false;
    }

    if (type === 'hour') {
      if (value.length > 5) {
        return false;
      }

      if (value.length === 2 && !value.includes(':')) {
        return `${value}:`;
      }

      if (value.length === 2 && value.includes(':')) {
        return false;
      }

      if (value.length === 3 && value.includes(':')) {
        return `${value[0]}${value[2]}:`;
      }

      if (value.length === 5 && value.includes(':')) {
        return `${value[0]}${value[1]}:${value[3]}${value[4]}`;
      }
    }

    return value;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const validatedValue = handleValidation(newValue);
    
    if (validatedValue !== false) {
      setInputValue(validatedValue);
      onChange && onChange(validatedValue);
    }
  };

  // Update internal state when value prop changes
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <>
      <div className={`input-text-container ${containerClassName || ''}`}>
        <label htmlFor={name} className={`input-text-label ${error ? 'error' : ''}`}>
          {label}
          {required && <span className="input-text-required"> *</span>}
        </label>
        {/* {helperText && <Tooltip target={`.helper-${name}`} content={helperText} />} */}
        {handleOpenHelper && (
          <AppIcon
            icon="mdi:help-circle-outline"
            className={`input-text-helper helper-${name}`}
            width={30}
            onClick={handleOpenHelper}
          />
        )}
        <input
          className={`input-text-input ${className || ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
          id={name}
          value={inputValue}
          type={type === 'password' ? (seePass ? 'text' : type) : type === 'time' || type === 'date' ? type : 'text'}
          onChange={handleInputChange}
          maxLength={maxLength}
          placeholder={placeholder}
          disabled={disabled}
        />
        {type === 'password' && (
          <AppIcon
            icon={seePass ? 'mdi:eye-off' : 'mdi:eye'}
            className="input-text-password-toggle"
            width={30}
            onClick={() => setSeePass(!seePass)}
          />
        )}
        {error && <small className="input-text-error">{error}</small>}
      </div>
    </>
  );
};

export default InputText;
